import Vue from 'vue'
import VueRouter from 'vue-router'
import account from '@/router/account'
import home from '@/router/home'
import documents from '@/router/documents'
import Console from '@/router/console'
import {LoginGuard,infoGuard} from '@/router/guard'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Index.vue'),
    children: [
      ...home,
      ...account,
    ],
  },
  {
    path: '/documents',
    component: () => import('@/components/documents/Index.vue'),
    children: [
      ...documents,
    ],
  },
  {
    path: '/console',
    component: () => import('@/views/console/Index.vue'),
    children: [
      ...Console,
    ],
    beforeEnter: (to, from, next) => (LoginGuard(to, from, next) && infoGuard(to, from, next)) && next(),
  },
  {
    path: '*',
    name: '*',
    component: () => import('@/components/Error.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})
router.beforeEach((to, from, next) => {
  if(to.meta && to.meta['key']){ // 是否需要面包屑
    //记录面包屑资料到vuex
    window.$store.commit("breadcrumbStore/setKeyBreadcrumb", {
      key: to.meta.key, 
      name: to.meta.title, 
      path: to.fullPath
    });
  }
  next();
});
export default router